export interface Tomo {
  number: string
  accentEmoji: string
  title: string
  subtitle: string
  result: string
}

export const TOMOS: Tomo[] = [
  {
    number: '01',
    accentEmoji: '🟢',
    title: 'Los Pilares de la Recuperación',
    subtitle:
      'Entendé por qué tu cuerpo no se recupera aunque descanses y qué está frenando tu progreso.',
    result: 'Claridad total sobre tu punto de partida.',
  },
  {
    number: '02',
    accentEmoji: '🟡',
    title: 'Recuperación Muscular Acelerada',
    subtitle:
      'Técnicas concretas para reducir el dolor muscular y volver a entrenar antes.',
    result: 'Más entrenamientos por semana. Sin forzar.',
  },
  {
    number: '03',
    accentEmoji: '🟠',
    title: 'Movilidad y Articulaciones de Acero',
    subtitle:
      'Protocolo semanal para moverte mejor y dejar de tener siempre la misma molestia.',
    result: 'Menos dolores. Más continuidad.',
  },
  {
    number: '04',
    accentEmoji: '🔵',
    title: 'El Sueño del Deportista',
    subtitle:
      'Optimizá las horas que ya dormís para que tu cuerpo se repare de verdad mientras descansa.',
    result: 'Te levantás con energía real.',
  },
  {
    number: '05',
    accentEmoji: '🔴',
    title: 'Nutrición para Recuperar y Rendir',
    subtitle:
      'Usá lo que comés como herramienta de recuperación. Sin dietas complicadas ni gastar de más.',
    result: 'Tu alimentación trabaja para vos.',
  },
  {
    number: '06',
    accentEmoji: '⭐',
    title: 'El Sistema del Deportista Incansable',
    subtitle:
      'Todo el método integrado en protocolos diarios y semanales listos para aplicar desde hoy.',
    result: 'Un sistema completo. Sin improvisar.',
  },
]

export interface Bono {
  number: string
  title: string
  description: string
  value: string
}

export const BONOS: Bono[] = [
  {
    number: 'BONO 1',
    title: 'Los 25 Errores que Te Están Frenando',
    description:
      'Los errores más comunes que frenan la recuperación — y cómo corregirlos hoy mismo.',
    value: '$12.000 ARS',
  },
  {
    number: 'BONO 2',
    title: 'Protocolos Express 15, 30 y 60 min',
    description:
      'Tres protocolos listos para usar según el tiempo que tengas disponible ese día.',
    value: '$10.000 ARS',
  },
  {
    number: 'BONO 3',
    title: 'Test de Fatiga y Autodiagnóstico',
    description:
      'Sabé exactamente cuándo apretar y cuándo aflojar para no quemarte ni frenar el progreso.',
    value: '$12.000 ARS',
  },
]

export interface Testimonial {
  initials: string
  quote: string
  name: string
  role: string
}

export const TESTIMONIALS: Testimonial[] = [
  {
    initials: 'MG',
    quote:
      'En dos semanas de aplicar el Tomo 2 ya noto la diferencia. Antes tardaba 3 o 4 días en recuperarme de una sesión de piernas. Ahora en 48 horas estoy listo para volver. Esto es lo que me faltaba.',
    name: 'Matías G., Buenos Aires',
    role: 'Crossfitter Amateur',
  },
  {
    initials: 'RV',
    quote:
      'El Tomo 4 me cambió el sueño literalmente. Dormía mal hace meses y pensaba que era estrés del trabajo. Apliqué el protocolo de la semana 1 y en 10 días empecé a despertar descansado de verdad.',
    name: 'Romina V., Rosario',
    role: 'Runners y Mamá',
  },
  {
    initials: 'LS',
    quote:
      'El Bono 3 me salvó de lesionarme. Tenía señales de sobreentrenamiento que no reconocía. El test me dijo claramente que tenía que bajar la carga. Dos semanas después volví mejor que antes.',
    name: 'Lucas S., Córdoba',
    role: 'Futbolista Amateur',
  },
]

export const MORE_TESTIMONIALS: Testimonial[] = [
  {
    initials: 'PL',
    quote:
      'Llevaba 8 meses con una molestia en la rodilla derecha que nadie me explicaba bien. Apliqué el módulo de rodilla del Tomo 3 y en 3 semanas desapareció. No lo puedo creer todavía.',
    name: 'Pablo L., Tucumán',
    role: 'Ciclista Amateur',
  },
  {
    initials: 'NA',
    quote:
      'Con el Bono 3 me di cuenta que estaba entrenando en rojo hace semanas. Bajé la carga 10 días, apliqué los protocolos de recuperación y volví con más fuerza que antes del «descanso».',
    name: 'Natalia A., Mendoza',
    role: 'Practicante de Artes Marciales',
  },
  {
    initials: 'DM',
    quote:
      'En 2 meses pasé de entrenar 3 veces por semana a 5. No porque me mate más sino porque me recupero mejor. El Tomo 2 y el Tomo 5 juntos son una locura.',
    name: 'Diego M., Salta',
    role: 'Jugador de Pádel Amateur',
  },
]

export const PAIN_POINTS: string[] = [
  'Entrenás fuerte toda la semana pero los resultados no aparecen como esperabas',
  'Siempre estás cansado, con las piernas pesadas o con alguna molestia que no termina de irse',
  'Querés entrenar más seguido pero el cuerpo no te da',
  'Escuchás hablar de recuperación activa, proteólisis y ventana anabólica pero no sabés qué aplicar sin volverte loco',
  'Tus músculos tardan días en recuperarse y cuando volvés al gym no rendís igual',
  'Tenés molestias en rodillas, hombros o espalda que se repiten siempre en el mismo lugar',
  'Dormís 7 u 8 horas y de todas formas te levantás sin energía',
  'Ves atletas de tu nivel que progresan más rápido y no entendés qué están haciendo diferente',
]

export interface ValueRow {
  label: string
  value: string
}

export const VALUE_ROWS: ValueRow[] = [
  { label: '6 Tomos del Sistema', value: '$48.000 ARS' },
  {
    label: 'Bono 1: Los 25 Errores que Te Están Frenando',
    value: '$12.000 ARS',
  },
  {
    label: 'Bono 2: Protocolos Express (15, 30 y 60 min)',
    value: '$10.000 ARS',
  },
  { label: 'Bono 3: Test de Fatiga y Autodiagnóstico', value: '$12.000 ARS' },
  { label: 'Biomecánica Premium', value: '$15.000 ARS' },
]

export const VALUE_TOTAL = '$97.000 ARS'
export const PRICE_TODAY = '$19.900 ARS'

export interface FaqItem {
  question: string
  answer: string
}

export const FAQS: FaqItem[] = [
  {
    question: '¿Cómo recibo el Megapack?',
    answer:
      'Al confirmar el pago por Mercado Pago, recibís el link de descarga por mail en menos de 5 minutos.',
  },
  {
    question: '¿Sirve si recién empiezo a entrenar?',
    answer:
      'Es exactamente para eso. El Tomo 1 arranca desde cero, sin conocimientos previos. Si ya entrenás hace años, los tomos avanzados te van a cambiar la forma de pensar el entrenamiento.',
  },
  {
    question: '¿Es específico para Argentina?',
    answer:
      'Completamente. El contexto, los ejemplos y los recursos están adaptados al deportista amateur argentino de 2026. No es una traducción de contenido extranjero.',
  },
  {
    question: '¿Funciona para cualquier deporte?',
    answer:
      'Sí. El sistema está diseñado para gimnasio, running, fútbol, pádel, crossfit, artes marciales y ciclismo. Cada tomo incluye ejemplos por deporte.',
  },
  {
    question: '¿El Ebook Premium está incluido?',
    answer:
      'Sí. Todo lo que ves en esta página está incluido en los $19.900 ARS. Sin costos extra. Sin upsells sorpresa.',
  },
  {
    question: '¿Los archivos son editables?',
    answer:
      'Los tomos son PDF de alta calidad. Los protocolos y checklists están diseñados para imprimirlos o usarlos directamente desde el celular.',
  },
  {
    question: '¿Tiene garantía real?',
    answer:
      '7 días, 100% del dinero, sin preguntas. Si no es lo que esperabas, te devolvemos todo. Sin formularios raros ni burocracia.',
  },
]

export interface ComparisonRow {
  without: string
  with: string
}

export const COMPARISON_ROWS: ComparisonRow[] = [
  {
    without: 'Días de recuperación perdidos sin entender por qué',
    with: 'Control total de tu recuperación semana a semana',
  },
  {
    without: 'Molestias que se repiten siempre en el mismo lugar',
    with: 'Protocolo de prevención articular activo',
  },
  {
    without: '«Descansé pero igual estoy cansado»',
    with: 'Sueño optimizado que trabaja para vos',
  },
  {
    without: 'Miedo a lesionarte o ya lesionado otra vez',
    with: 'Criterio propio para saber cuándo apretar y cuándo aflojar',
  },
  {
    without: 'Progresos lentos a pesar de entrenar mucho',
    with: 'Más entrenamientos, mejor recuperación, más progreso',
  },
  {
    without: 'Sin sistema ni plan de largo plazo',
    with: 'Hoja de ruta para los próximos 90 días y más allá',
  },
]

// Images
export const HERO_MOCKUP =
  'https://images.unsplash.com/photo-1517836357463-d25dfeac3438?auto=format&fit=crop&w=1600&q=80'
export const EBOOK_COVER =
  'https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?auto=format&fit=crop&w=900&q=80'
export const MERCADO_PAGO_LOGO =
  'https://logospng.org/download/mercado-pago/logo-mercado-pago-icone-512.png'
